// Import from node_modules at the root level
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import api from '@/services/axios'
window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT,
  wssPort: import.meta.env.VITE_REVERB_PORT,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
  authorizer: (channel, options) => {
    return {
      authorize: (socketId, callback) => {
        api
          .post(`${import.meta.env.VITE_API_URL}/broadcasting/auth`, {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response: any) => {
            callback(false, response.data)
          })
          .catch((error: any) => {
            callback(true, error)
          })
      }
    }
  }
})
